<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Laboratory Stock",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Items Disbursed In LAB",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Laboratory Stock",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "item",
          sortable: true,
          label: "ITEM",
        },
        {
          key: "requester.name",
          sortable: true,
          label: "REQUESTED BY",
        },
        {
          key: "requestDate",
          sortable: true,
          label: "REQUESTED ON",
        },
        {
          key: "approver.name",
          sortable: true,
          label: "APPROVED BY",
        },
        {
          key: "disburser.name",
          sortable: true,
          label: "DISBURSED BY",
        },
        {
          key: "disburseDate",
          sortable: true,
          label: "DISBURSED ON",
        },
      ],

      // Value from user input for adding position
      data: {
        name: "",
      },
    };
  },
  computed: {
    ...mapGetters("inventory", ["DisbursedStock"]),
    ...mapGetters("auth", ["user_permissions"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.DisbursedStock ? this.DisbursedStock.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.DisbursedStock ? this.DisbursedStock.length : 1;
  },
  methods: {
    ...mapActions({
      FetchDisbursedStock: "inventory/fetchDisbursed",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  created() {
    this.FetchDisbursedStock();
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="DisbursedStock ? DisbursedStock : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(item)="data">
                  <table class="table">
                    <thead>
                      <tr>
                        <th width="40%">Item</th>
                        <th width="20%">Requested</th>
                        <th width="20%">Approved</th>
                        <th width="20%">Disbursed</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(itm, i) in data.item.details" :key="i">
                        <td width="40%">{{ itm.item.itemName }}</td>
                        <td width="20%">
                          {{ itm.itemQty }}
                          {{ itm.item.unit ? itm.item.unit.symbol : "" }}
                        </td>
                        <td width="20%">
                          {{ itm.approvedQty }}
                          {{ itm.item.unit ? itm.item.unit.symbol : "" }}
                        </td>
                        <td width="20%">
                          {{ itm.issuedQty }}
                          {{ itm.item.unit ? itm.item.unit.symbol : "" }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </template>
              </b-table>
              <center>
                <h3 v-if="!DisbursedStock" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </center>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
